export default "__VITE_ASSET__keUREM$q__"